import React from 'react';

const TaskStats = ({ tasks }) => {
  const stats = {
    total: tasks.length,
    pending: tasks.filter(t => t.status === 'pending').length,
    inProgress: tasks.filter(t => t.status === 'in_progress').length,
    registered: tasks.filter(t => t.status === 'registered').length,
    overdue: tasks.filter(t => t.status === 'overdue').length,
    hot: tasks.filter(t => t.temperature === 'hot').length,
    warm: tasks.filter(t => t.temperature === 'warm').length,
    cold: tasks.filter(t => t.temperature === 'cold').length
  };

  const completionRate = stats.total > 0 ? (stats.registered / stats.total) * 100 : 0;

  const statCards = [
    {
      title: 'Total Tasks',
      value: stats.total,
      icon: '📋',
      color: '#1976d2'
    },
    {
      title: 'In Progress',
      value: stats.inProgress,
      icon: '⏳',
      color: '#ed6c02'
    },
    {
      title: 'Registered',
      value: stats.registered,
      icon: '✅',
      color: '#2e7d32'
    },
    {
      title: 'Overdue',
      value: stats.overdue,
      icon: '⚠️',
      color: '#d32f2f'
    }
  ];

  return (
    <div style={{ marginBottom: '24px' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginBottom: '16px' }}>
        {statCards.map((stat, index) => (
          <div
            key={index}
            style={{
              background: 'white',
              padding: '20px',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              border: '1px solid #e0e0e0'
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div>
                <div style={{ fontSize: '14px', color: '#666', marginBottom: '4px' }}>
                  {stat.title}
                </div>
                <div style={{ fontSize: '32px', fontWeight: '600', color: '#333' }}>
                  {stat.value}
                </div>
              </div>
              <div style={{ fontSize: '24px', color: stat.color }}>
                {stat.icon}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div style={{
        background: 'white',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        border: '1px solid #e0e0e0'
      }}>
        <h3 style={{ margin: '0 0 16px 0', fontSize: '18px', fontWeight: '600' }}>
          Overall Progress
        </h3>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <div style={{
            flexGrow: 1,
            height: '8px',
            background: '#e0e0e0',
            borderRadius: '4px',
            overflow: 'hidden'
          }}>
            <div style={{
              height: '100%',
              width: `${completionRate}%`,
              background: '#2e7d32',
              transition: 'width 0.3s ease'
            }} />
          </div>
          <div style={{ fontSize: '14px', color: '#666', minWidth: '50px' }}>
            {completionRate.toFixed(1)}%
          </div>
        </div>
      </div>

      <div style={{
        background: 'white',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        border: '1px solid #e0e0e0',
        marginTop: '16px'
      }}>
        <h3 style={{ margin: '0 0 16px 0', fontSize: '18px', fontWeight: '600' }}>
          Temperature Distribution
        </h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px' }}>
          <div style={{ textAlign: 'center', padding: '12px', background: '#ffebee', borderRadius: '6px' }}>
            <div style={{ fontSize: '20px', marginBottom: '4px' }}>🔥</div>
            <div style={{ fontSize: '18px', fontWeight: '600', color: '#d32f2f' }}>{stats.hot}</div>
            <div style={{ fontSize: '12px', color: '#666' }}>Hot</div>
          </div>
          <div style={{ textAlign: 'center', padding: '12px', background: '#fff3e0', borderRadius: '6px' }}>
            <div style={{ fontSize: '20px', marginBottom: '4px' }}>🌡️</div>
            <div style={{ fontSize: '18px', fontWeight: '600', color: '#f57c00' }}>{stats.warm}</div>
            <div style={{ fontSize: '12px', color: '#666' }}>Warm</div>
          </div>
          <div style={{ textAlign: 'center', padding: '12px', background: '#e3f2fd', borderRadius: '6px' }}>
            <div style={{ fontSize: '20px', marginBottom: '4px' }}>❄️</div>
            <div style={{ fontSize: '18px', fontWeight: '600', color: '#1976d2' }}>{stats.cold}</div>
            <div style={{ fontSize: '12px', color: '#666' }}>Cold</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaskStats;